import { isIPBypassed } from '../IP/isIPBypassed'
import { normalizeForwardedClientIp } from '../IP/normalizeForwardedClientIp'
import { getMaintenanceStatusPayload } from './getMaintenanceStatusPayload'

export type MaintenanceBypassResult = {
    isBypassed: boolean
}

export const getMaintenanceBypassForRequest = async (request: Request): Promise<MaintenanceBypassResult> => {
    const payload = await getMaintenanceStatusPayload()
    const appStatus =
        payload.currentAppStatus ?? (payload.appName ? payload.apps[payload.appName] : undefined)
    if (!appStatus?.enabled) {
        return { isBypassed: false }
    }

    const rawClientIP =
        request.headers.get('x-forwarded-for')?.split(',')[0]?.trim() ||
        request.headers.get('x-real-ip')?.trim() ||
        ''
    const clientIP = normalizeForwardedClientIp(rawClientIP)

    if (!clientIP || payload.bypassIPs.length === 0) {
        return { isBypassed: false }
    }

    const isBypassed = isIPBypassed(clientIP, payload.bypassIPs)
    return { isBypassed }
}
